import React, { Component } from 'react'
import './vRegistration.css';
import { fire, vanRegistration } from '../../config/firebase'

export default class Registration extends Component {
    state={
        name:'',dob:'',id:'',zip:'',
        city:'',state:'',street:'',location:'',
        modelo:'',placa:'',lotacao:'',
        cnh:'',licenca:'',
        registered:false,showRegstration:false,
    }
     componentDidMount(){
       let data = localStorage.getItem('van');
    //    let data  = {name:'Aijaz',uid:'123',photo:'6767364'}
       if(data){
           let user = JSON.parse(data);
        //    let user = data
           console.log('__________________',user)
           this.setState({
               name:user.name,
               uid:user.uid,
               photo:user.photo,
           })
           try {
    
            fire.firestore().collection('vanRegistration').onSnapshot(snap=>{
                snap.forEach(val=>{
                    if(val.id === user.uid){
                        // alert(val.id+' = '+user.uid+'______ '+true);
                        this.setState({
                            registered:true
                        })
                        this.props.history.push('/driver/vanRoutine')
                    }else{
                        this.setState({
                            showRegstration:true
                        })
                    }
                })
            })
        } catch (error) {
            alert(error)
        }
           
           navigator.geolocation.getCurrentPosition((location) => {
               this.setState({
                   lat: location.coords.latitude,
                   lng: location.coords.longitude
                })
            });
        }else{
            // alert('Please Login first..')
            this.props.history.push('/')
        }
    }
    
      async register(){
           let { 
               name,
               id,
               zip,
               city,
               state,
               street,
               
                modelo,
                placa,
                lotacao,
                cnh,
                licenca,
               uid,
               lat,
               lng,
               photo,
           } = this.state
          
          let zip_error = zip ? '' : 'Por favor insira seu CEP';
          let state_error = state ? '':'Por favor insira seu Estado';
          let city_error = city ? '':'Por favor insira seu Cidade';
          let street_error = street ? '':'Por favor insira seu Rua';
        //   let location_error =lat?'': location ? '':'Por favor insira seu location..';
          let modelo_error = modelo ? '':'Por favor insira seu modelo';
          let placa_error = placa ? '':'Por favor insira seu placa';
          let lotacao_error = lotacao ? '':'Por favor insira seu lotacao';
          let cnh_error = cnh ? '':'Por favor insira seu CNH';
          let licenca_error = licenca ? '':'Por favor insira seu licence';
          
           this.setState({
               state_error,
               city_error,
               street_error,
            //    location_error,
               modelo_error,
               placa_error,
               lotacao_error,
               cnh_error,
               licenca_error,
               zip_error,
            })
            if( !state_error && !city_error && !street_error && !modelo_error && !placa_error && !lotacao_error && !cnh_error && !licenca_error){
               let userData ={ 
                name,
               id,
               zip,
               city,
               state,
               street,
               location:lat ?{lat,lng}:'',
                modelo,
                placa,
                lotacao,
                cnh,
                licenca,
               uid,
               photo,
            }
            try {
                
                await vanRegistration(userData,uid)
                alert('success')
                this.props.history.push('/driver/vanRoutine');
            } catch (error) {
                alert(error)
            }
            }else{
                this.setState({
                    error:'Por favor preencha o formulário corretamente...'
                })
            }
       }

 

        //_________________VAN_PLATE_______________//
        placa_input = async (value) =>{
          
            let possibilty_1 = /\b([a-z]{3})-([0-9]{4})\b/
            let test_1 = possibilty_1.test(value.toLowerCase());
            console.log('test_1',test_1)
            if(test_1 ){
                // console.log()
                this.setState({
                    placa:value.toLowerCase(),placa_error:''
                })
            }else{
                this.setState({placa_error:value+' Não é um formato correto.formato correto é  XXX-1111.  '})
            }
        }

         //_________________CEP_______________//
      cep = async (value) =>{
          
        let possibilty_1 = /\b([0-9]{2}).([0-9]{3})-([0-9]{3})\b/
        let test_1 = possibilty_1.test(value.toLowerCase());
        console.log('test_1',test_1)
        if(test_1 ){
            this.setState({
                zip:value.toLowerCase(),zip_error:''
            })
        }else{
            this.setState({zip_error:value+' Não é um formato correto.formato correto é XX.XXX-XXX.  '})
        }
    }

    _logout(){
        fire.auth().signOut().then(s=>{
            // alert('logout com sucesso')
            localStorage.removeItem('van')
            this.props.history.push('/')
        }).catch(e=>{
            alert(e.message)
        })
    }
    
    render() {
        let { 
            state_error,
               city_error,
               street_error,
               modelo_error,
               placa_error,
               lotacao_error,
               cnh_error,
               licenca_error,
               error,
               zip_error,
               registered,
               showRegstration,
        } = this.state
        return (
            <div>
 {!registered && !showRegstration &&
                <div className='main'>
                <div className='r_panel' style={{minHeight:'100vh',justifyContent:'center',flexDirection:'column'}}>
                     

                <div className='r_hd'  style={{alignSelf:'center',display:'flex',flexDirection:'column'}}>
<p onClick={()=>this._logout()}>{"< De volta"}</p>
                   <h2 style={{display:'block'}}>
                   Estamos verificando seu registro...
                       </h2 >
            
                    <div style={{display:'block',alignSelf:'center'}} className="loader"></div> 
                    </div>
                    </div>
                </div>
                }
{
                   showRegstration  &&
           <div className='main'>
               <div className='r_panel'>
                   <div className='r_hd'>

                   <p onClick={()=>this._logout()}>{"<"}</p>
                   <h3>SOU MOTORISTA</h3>
                   <span></span>
                   </div>

                   <div className='form' style={{maxWidth:'1200px',alignSelf:'center'}}>
                      <p>
                      Crie um perfil para deixarmos sua Van disponível para passageiros na região
                      </p>
                      <div className='inputs'>
                      <div className='inp'>
                      <label>Nome</label>
                      <input type="text" value={this.state.name} placeholder='Enter your name '/> 
                          </div>
<div className='inp'>
                      {!zip_error ?<label>CEP</label>
:<label style={{color:'red'}}>{zip_error}</label>}
                      <input maxLength='10' onChange={(event)=>this.cep(event.target.value)}   placeholder='12.345-000'/> 
                      </div>

                      <div className='inp'>
                      {!city_error ?<label>Cidade</label>
:<label style={{color:'red'}}>{city_error}</label>}
                      <input maxLength='40' onChange={(event)=>{this.setState({city:event.target.value})}} type="text" placeholder='Cidade'/> 
                      </div>

                      <div className='inp'>
                      {!state_error ?<label>Estado</label>
:<label style={{color:'red'}}>{state_error}</label>}
                      <input maxLength='40' onChange={(event)=>{this.setState({state:event.target.value})}} type="text" placeholder='Estado'/> 
                      </div>

                      <div className='inp'>
                      {!street_error ?<label>Rua</label>
:<label style={{color:'red'}}>{street_error}</label>}
                      <input maxLength='25' onChange={(event)=>{this.setState({street:event.target.value})}} type="text" placeholder='Rua'/> 
                      </div>

                      <div className='inp'>
                      {!modelo_error ?<label>Modelo</label>
:<label style={{color:'red'}}>{modelo_error}</label>}
                      <input maxLength='30' onChange={(event)=>{this.setState({modelo:event.target.value})}} type="text" placeholder='Modelo'/>
                      </div>
                      <div className='inp'>
                      {!placa_error ?<label>Placa</label>
:<label style={{color:'red'}}>{placa_error}</label>}
                      <input maxLength='8' onChange={(event)=>{this.placa_input(event.target.value)}} type="text" placeholder='jfv-3333'/>
                      </div>

                      <div className='inp'>
                      {!lotacao_error ?<label>Lotacao</label>
:<label style={{color:'red'}}>{lotacao_error}</label>}
                      <input maxLength='30' onChange={(event)=>{this.setState({lotacao:event.target.value})}} type="text" placeholder='Lotacao'/> 
                      </div>
                      
                      <div className='inp'>
                      {!cnh_error ?<label>CNH</label>
:<label style={{color:'red'}}>{cnh_error}</label>}
                      <input maxLength='30' onChange={(event)=>{this.setState({cnh:event.target.value})}} type="text" placeholder='CNH'/> 
                      </div>
                      <div className='inp'>
                      {!licenca_error ?<label>Licenca</label>
:<label style={{color:'red'}}>{licenca_error}</label>}
                      <input maxLength='30' onChange={(event)=>{this.setState({licenca:event.target.value})}} type="text" placeholder='Licenca'/> 
                      
                      </div>
                      <div className='inp'>
                          <label>Turno</label>
                          <div style={{display:'flex',justifyContent:'space-around'}}>
<div>
                     <label style={{display:'block'}}>Minha</label>
                      <input  className='_ii_' type='checkbox'/> 
</div>
<div>
                     <label style={{display:'block'}}>Trade</label>
                      <input  className='_ii_' type='checkbox'/> 
</div>
<div>
                     <label style={{display:'block'}}>Noite</label>
                      <input  className='_ii_' type='checkbox'/> 
</div>
                         </div>
                      
               {error && <p>{error}</p>}
                      </div>

                     
                      
                      </div>


               </div>
               <button onClick={()=>{this.register()}} className='rg_btn'>CADASTRAR</button>
           </div>
                   </div>

}
</div>
        )
    }
}
